import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal } from "../Reveal";

const FAQ = [
  ["How do I join?", "Create an account with your email or Google, pick a tier, and check out securely with Stripe. Your feed unlocks the moment payment is confirmed."],
  ["Can I upgrade later?", "Yes. Upgrade anytime from the Membership page — your new tier replaces the old subscription automatically."],
  ["Who can message Katie?", "Every member can message Katie directly from the Messages page."],
  ["What are pay-per-view posts?", "Some special posts carry a one-time price on top of your tier. Pay once and the post stays unlocked for as long as you're a member."],
  ["How do tips work?", "Every member can send a tip on any post they can see. Tips are one-time payments, handled by Stripe."],
];

export const Faq = () => (
  <section data-testid="faq-section" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-32 grid lg:grid-cols-12 gap-10">
    <Reveal className="lg:col-span-4">
      <p className="eyebrow mb-5">04 — Questions</p>
      <h2 className="font-display text-3xl sm:text-4xl text-[#0E1B3D]">Before you <span className="italic text-[#D7263D]">step in.</span></h2>
    </Reveal>
    <Reveal className="lg:col-span-8" delay={0.1}>
      <Accordion type="single" collapsible className="border-t border-[#0E1B3D]/10">
        {FAQ.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`} className="border-b border-[#0E1B3D]/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-7 text-left font-display text-xl sm:text-2xl text-[#0E1B3D] hover:no-underline hover:text-[#D7263D]">{q}</AccordionTrigger>
            <AccordionContent className="pb-7 text-base text-[#4A5878] leading-relaxed max-w-2xl">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
